import gql from 'graphql-tag'

const GC_GET_LOG_TYPE_LIST = gql`
query GetLogTypeList {
    log_type {
      id
      name
      slug
    }
  }
`

const GC_GET_LOG_LIST = gql`
query GetLogList {
    logs {
      id
      data_key
      data
      logType {
        id
        slug
      }
      user_id
    }
  }
`

const GC_GET_LOG_BY_TYPE_SLUG = gql`
query LogsByType($type_slug: String!, $user_id: uuid!) {
  logs(where: {logType: {slug: {_eq: $type_slug}}, user_id: {_eq: $user_id}}, order_by: {updated_at: asc}) {
    id
    data_key
    data
    logType {
      id
      slug
    }
    user_id
  }
}
`

const GC_GET_LOG_HISTORY_BY_TYPE_SLUGS = gql`
query LogsByTypes($type_slugs: [String!]!, $user_id: uuid!) {
  logs(limit: 10, where: {logType: {slug: {_in: $type_slugs}}, user_id: {_eq: $user_id}}, order_by: {updated_at: desc}) {
    id
    data_key
    data
    logType {
      id
      slug
    }
    user_id
  }
}
`

const GC_GET_LOG_BY_DATA_KEY_AND_TYPE_SLUG = gql`
query LogsByDataKeyAndType($type_slug: String!, $data_key: uuid!, $user_id: uuid!) {
  logs(where: {logType: {slug: {_eq: $type_slug}}, data_key: {_eq: $data_key}, user_id: {_eq: $user_id}}, order_by: {updated_at: asc}) {
    id
    data_key
    data
    logType {
      id
      slug
    }
    user_id
  }
}
`

const GC_GET_LOG_BY_DATA_KEYS_AND_TYPE_SLUG = gql`
query LogsByDataKeysAndType($type_slug: String!, $data_keys: [uuid!]!, $user_id: uuid!) {
  logs(where: {logType: {slug: {_eq: $type_slug}}, data_key: {_in: $data_keys}, user_id: {_eq: $user_id}}, order_by: {updated_at: asc}) {
    id
    data_key
    data
    logType {
      id
      slug
    }
    user_id
  }
}
`

const GC_GET_LOG_BY_DATA_KEY = gql`
query LogByDataKey($data_key: uuid!, $user_id: uuid!) {
  logs(where: {data_key: {_eq: $data_key}, user_id: {_eq: $user_id}}, order_by: {updated_at: asc}) {
    id
    data_key
    data
    logType {
      id
      slug
    }
    user_id
  }
}
`

// // ------------- Game Data Examples -------------
// // "game_id": "012427f8-40a3-455d-8495-59c4045b47d6",
// // "game_name": "test",
// // "successed": true,
// // "scenario_id": "90b4d505-0c44-4058-890b-c3d6f0ede0cd",
// // "scenario_number": 0

// // const GC_GET_GAME_LOGS_ALL = gql`
// // query GetAllGames {
// //     game_logs:logs(where: {logType: {name: {_eq: "game"}}}) {
// //       data
// //     }
// //   }
// // `

// //Taux de reussite aux exercices par utilisateur
// const GC_GET_GAME_LOGS_BY_USERID = gql`
// query GameLogByID($id:uuid!) {
//     game_logs_by_id: logs(where: {logType: {name: {_eq: "game"}}, user_id: {_eq: $id}}) {
//       data
//     }
//   }
// `

// //Taux de réussite aux exercices global et taux de reussite moyen 
// const GC_GET_GAME_LOGS_BY_ORGA = gql`
// query GameLogByOrga($id:uuid!) {
//     game_logs_by_id: logs(where: {logType: {name: {_eq: "game"}}, users: {userOrganisations: {organisation: {_eq: $id}}}}) {
//       data
//     }
//   }
// `

// //Log quand l'utilisateur a fini un minijeu
// const GC_LOG_USER_GAME_DONE = gql`
// mutation InsertGameLogForUser($id: uuid!, $data: jsonb, $log_type_id: uuid!) {
//     insert_logs_one(object: { user_id: $id, $log_type_id: uuid! }) {
//       data
//     }
//   }
// `

// // ------------- Scenarios Examples -------------
// // {
// //   "scenario_id": "90b4d505-0c44-4058-890b-c3d6f0ede0cd",
// //   "scenario_number": 0,
// //   "start_place": 'String or uuid'
// // }

// //A log quand un utilisateur finit un scenario
// const GC_LOG_SCENARIO_END = gql`
// mutation LogScenarioEnd($id: uuid!, $data: jsonb, $log_type_id: uuid!) {
//   insert_logs_one(object: { user_id: $id, $log_type_id: uuid! }) {
//     data
//   }
// }`

// //A log quand un utilisateur commence un scenario
// const GC_LOG_SCENARIO_START = gql`
// mutation LogScenarioEnd($id: uuid!, $data: jsonb, $log_type_id: uuid!) {
//   insert_logs_one(object: { user_id: $id, $log_type_id: uuid! }) {
//     data
//   }
// }`

// // const GC_GET_SCENARIO_START_LOG_ALL = gql`
// // query ScenarioStartAll {
// //   logs(where: {logType: {name: {_eq: "scenario_start"}}}) {
// //     data
// //     id
// //   }
// // }
// // `

// //Sequences parcourues
// const GC_GET_SCENARIO_START_LOG_BY_USERID = gql`
// query ScenarioStartByUser($id: uuid!) {
//   logs(where: {logType: {name: {_eq: "scenario_start"}}, user_id: {_eq: $id}}) {
//     data
//     id
//   }
// }`


// // const GC_GET_SCENARIO_END_LOG_ALL = gql`
// // query ScenarioEndAll {
// //   logs(where: {logType: {name: {_eq: "scenario_end"}}}) {
// //     data
// //     id
// //   }
// // }
// // `

// //Utilisateurs ayant fini (par orga)
// const GC_GET_SCENARIO_END_LOG_BY_ORGA = gql`
// query ScenarioEndByOrga($id: uuid!) {
//   logs(where: {logType: {name: {_eq: "scenario_end"}}, users: {userOrganisations: {organisation: {_eq: $id}}}}) {
//     data
//     id
//   }
// }
// `

// //Les etoiles scenario terminé par utilisateur
// const GC_GET_SCENARIO_END_LOG_BY_USERID = gql`
// query ScenarioEndByUser($id: uuid!) {
//   logs(where: {logType: {name: {_eq: "scenario_end"}}, user_id: {_eq: $id}}) {
//     data
//     id
//   }
// }
// `


// // ------------- Login Example -------------
// // No data, we look at the created_at column for the timestamp

// //A log quand un utilisateur se connecte
// const GC_LOG_LOGIN = gql`
// mutation MyMutation($id: uuid!,$data: jsonb, $log_type_id: uuid!) {
//   insert_logs_one(object: { user_id: $id, $log_type_id: uuid! }) {
//     created_at
//   }
// }`

// //Date de connexion par utilisateur, à coupler avec le logout qui détient la durée de connexion (peut être mis en une requête)
// const GET_LOG_LOGIN_BY_PERIOD_BY_USERID = gql`
// query LoginByPeriod($from: timestamptz!, $to: timestamptz!, $id: uuid!) {
//   logs(where: {created_at: {_lte: $to, _gt: $from}, logType: {name: {_eq: "login"}}, user_id: {_eq: $id}}) {
//     created_at
//   }
// }
// `

// //Pour le nombre de connexions par periode par orga
// const GET_LOG_LOGIN_BY_PERIOD_BY_ORGA = gql`
// query LoginByPeriodOrga($from: timestamptz!, $to: timestamptz!, $id: uuid!) {
//   logs(where: {created_at: {_lte: $to, _gt: $from}, logType: {name: {_eq: "login"}}, users: {userOrganisations: {organisation: {_eq: $id}}}}) {
//     created_at
//   }
// }
// `


// // ------------- Logout Example -------------
// // {
// //   "duration": "1432" //En secondes, minutes, ou milisecondes, comme ti veux
// // }

// //A log quand un utilisateur se deconnecte, comparer avec le login Date pour avoir la duration
// const GC_LOG_LOGOUT = gql`
// mutation MyMutation($id: uuid!,$data: jsonb, $log_type_id: uuid!) {
//   insert_logs_one(object: { user_id: $id, $log_type_id: uuid! }) {
//     data
//   }
// }`


// const GET_LOG_LOGOUT_BY_PERIOD_BY_USERID = gql`
// query LogoutByPeriod($from: timestamptz!, $to: timestamptz!, $id: uuid!) {
//   logs(where: {created_at: {_lte: $to, _gt: $from}, logType: {name: {_eq: "logout"}}, user_id: {_eq: $id}}) {
//     created_at
//   }
// }
// `

// //Pour le temps de connexion moyen : moyenne de toutes les duration récupérées par cette requête
// const GC_LOG_LOGOUT_BY_PERIOD_BY_ORGANISATION =gql`
// query LogoutByPeriodOrga($from: timestamptz!, $to: timestamptz!, $id: uuid!) {
//   logs(where: {created_at: {_lte: $to, _gt: $from}, logType: {name: {_eq: "logout"}}, users: {userOrganisations: {organisation: {_eq: $id}}}}) {
//     created_at
//   }
// }
// `

// // ------------- Infos Formulaire de login -------------
// // Infos prises directement depuis la table user

// //Nombre de connexions uniques d'utilisateurs par organisation ET ratio d'experience des utilisateurs
// //Le role a ete defini comme "student", a changer si ce n'est pas le cas au final (role administrateur, ou role user etc)
// //Les utilisateurs actifs sont ceux inscrits ou ceux ayant eu un log de login ? Dans ce cas comparer les id des utilisateurs
// //inscrits par orga à ceux loggés
// const GC_GET_USER_INFO_BY_ORGA = gql`
// query UniqueConnexions($id: uuid!) {
//   users(where: {role: {_eq: "student"}, userOrganisations: {organisation: {_eq: $id}}}, distinct_on: created_at) {
//     id
//     created_at
//     experienced
//   }
// }
// `

const GC_ADD_LOG_ONE = gql`
mutation AddLog($data_key: uuid = null, $data: jsonb!, $log_type_id: uuid!, $user_id: uuid!) {
  insert_logs_one(object: {
    data_key: $data_key,
    data: $data,
    user_id: $user_id,
    log_type_id: $log_type_id
  }) {
    id
  }
}
`

const GC_UPDATE_LOG_ONE = gql`
mutation UpdateLog($id: uuid!, $data_key: uuid = null, $data: jsonb!, $log_type_id: uuid!, $user_id: uuid!) {
  update_logs_by_pk(pk_columns: { id: $id }, _set: {
    data_key: $data_key,
    data: $data,
    user_id: $user_id,
    log_type_id: $log_type_id
  }) {
    id
  }
}
`

const GC_ADD_LOG_ONE_DETAILS = gql`
mutation AddLog($data_key: uuid = null, $data: jsonb!, $log_type_id: uuid!, $user_id: uuid!) {
  insert_logs_one(object: {
    data_key: $data_key,
    data: $data,
    user_id: $user_id,
    log_type_id: $log_type_id
  }) {
    id
    data_key
    data
    logType {
      id
      slug
    }
    user_id
  }
}
`

export {
  GC_GET_LOG_TYPE_LIST,
  GC_GET_LOG_LIST,
  GC_GET_LOG_BY_TYPE_SLUG,
  GC_GET_LOG_HISTORY_BY_TYPE_SLUGS,
  GC_ADD_LOG_ONE_DETAILS,
  GC_ADD_LOG_ONE,
  GC_UPDATE_LOG_ONE,
  GC_GET_LOG_BY_DATA_KEY_AND_TYPE_SLUG,
  GC_GET_LOG_BY_DATA_KEYS_AND_TYPE_SLUG,
  GC_GET_LOG_BY_DATA_KEY
}